import { useAmpContext } from 'utils/AmpContext';

import { StyledRichText } from './StyledRichText';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function RichText(props: Record<string, any>) {
  const requestIsAmp = useAmpContext();

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <StyledRichText requestIsAmp={requestIsAmp} {...props} />;
}
